/* eslint-disable max-len */
import request from '@hb/sharp-request';
import requestDefault from '@/shared/utils/request';
import { newGatewayUrl } from '@/constant';
import platform from '@/shared/utils/platform';
import { landData } from '@/shared/utils/landData';
import { getActivityUndertakeType } from '@/shared/activity-undertake';
import { PageSceneEnum } from '../common/types';
import type {
  AliProductStatus, AutarkyStateType, CreditDataType, CurrentRepayBill, UserInfoProgress, UserCreditType, UserLoanType,
  HaiXiaoQueryStatusType,
} from './types';

/** 查询用户授信额度状态以及用户资料填写进度，首页专用 */
export const getHomeStatus = (): Promise<CreditDataType> => requestDefault.postGate(
  'f.loan.panel.queryUserProgress',
  {
    source: landData.getSouce(),
  },
  {
    showLoading: undefined,
  },
);

/** 查询用户授信额度状态 */
export const getUserCredit = (): Promise<UserCreditType> => requestDefault.postGate(
  'f.loan.panel.queryUserCredit',
  {
    source: landData.getSouce(),
  },
  {
    showLoading: undefined,
  },
);

/** 查询用户订单状态 */
export const getUserLoan = (): Promise<UserLoanType> => requestDefault.postGate(
  'f.loan.panel.queryUserLoan',
  {
    source: landData.getSouce(),
  },
  {
    showLoading: undefined,
  },
);

/** 查询用户资料填写进度 */
export const getUserInfoProgress = (showLoading = false):
Promise<UserInfoProgress> => requestDefault.postGate(
  'f.loan.panel.queryUserWriteProgress',
  {
    version: getActivityUndertakeType() ? undefined : '1.0.0',
  },
  showLoading ? undefined : { showLoading: undefined },
);

// 查询用户是否存在当期待还款和逾期订单
export const checkCurrentRepayBill = (): Promise<CurrentRepayBill> => requestDefault.postGate(
  'f.user.repay.state',
  {},
  { showLoading: undefined },
);


// 获取支付宝小程序环境当前放款状态
export const getAliProductStatus = (): Promise<AliProductStatus> => request.postGate(
  'f.product.maining.state',
  {
    ...platform.currentPlatformType,
  },
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
  },
);

/**
 * f.user.autarky.state(全局用户状态判断查询接口)
 * yapi: https://yapi.hellobike.cn/project/3415/interface/api/275687
 */
export const getUserAutarkyState = (): Promise<AutarkyStateType> => requestDefault.postGate<AutarkyStateType>(
  'f.user.autarky.state',
  {},
  {
    showLoading: undefined,
  },
);


/** 查询还款页实验结果 */
export const getRepaymentPageExperiment = ():
Promise<{
  hitExperiment: boolean;
}> => requestDefault.postGate(
  'f.repayment.page.experiment',
  {},
  { showErrMsg: undefined },
);

/**
 * 查询海消联合品牌展示状态
 * @yapi https://yapi.hellobike.cn/project/3415/interface/api/432495
 */
export const getHaiXiaoQueryStatus = (
  scene: PageSceneEnum,
): Promise<HaiXiaoQueryStatusType> => requestDefault.postGate<HaiXiaoQueryStatusType>(
  'f.credit.haixiao.queryStatus',
  {
    scene,
  },
  { showLoading: undefined },
);

const HomeV2Status = {
  getHomeStatus,
  getUserAutarkyState,
  getUserCredit,
  getUserLoan,
  getUserInfoProgress,
  getHaiXiaoQueryStatus,
};

export default HomeV2Status;
